namespace GeniuzPOS.Inventory {
    export enum CancelFgstatus {
        Use = 0,
        cancle = 1,
        posttocancle = 2
    }
    Serenity.Decorators.registerEnumType(CancelFgstatus, 'GeniuzPOS.Inventory.CancelFgstatus');
}
